var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommentBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3 0H1.7C0.762447 0 0 0.762462 0 1.70001V14.5858C0 15.4767 1.07714 15.9229 1.70711 15.2929L3.1071 13.8929C3.29464 13.7054 3.54899 13.6 3.81421 13.6H15.3C16.2375 13.6 17 12.8375 17 11.9V1.70001C17 0.762462 16.2375 0 15.3 0ZM10.2 8.5C10.2 8.96945 9.81945 9.35001 9.35001 9.35001H5.10001C4.63056 9.35001 4.25 8.96945 4.25 8.5C4.25 8.03055 4.63056 7.64999 5.10001 7.64999H9.35001C9.81945 7.64999 10.2 8.03055 10.2 8.5ZM12.75 5.10001C12.75 5.56945 12.3694 5.95001 11.9 5.95001H5.10001C4.63056 5.95001 4.25 5.56945 4.25 5.10001C4.25 4.63056 4.63056 4.25 5.10001 4.25H11.9C12.3694 4.25 12.75 4.63056 12.75 5.10001Z",
    fill: "#1B44FE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentBlue);
export default __webpack_public_path__ + "static/media/comment-blue.45bf2b2d00c6be0abdc2b210e24a1c8e.svg";
export { ForwardRef as ReactComponent };